// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__ConstructionPage__qnbHeader{margin-bottom:30px}.app__ConstructionPage__qnbConstructionFields{margin-bottom:20px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ml-capability-quoteandbind-common-react/pages/Construction/ConstructionPage.module.scss"],"names":[],"mappings":"AAAA,kCAEI,kBAAA,CAEJ,8CACI,kBAAA","sourcesContent":[".qnbHeader {\n    /* margin-top:  -45px;*/\n    margin-bottom: 30px;\n}\n.qnbConstructionFields {\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qnbHeader": "app__ConstructionPage__qnbHeader",
	"qnbConstructionFields": "app__ConstructionPage__qnbConstructionFields"
};
export default ___CSS_LOADER_EXPORT___;
